import { Injectable } from '@angular/core';
import { CeiPersonalDataMenuItem } from '@cei-ufg/ngx-arquitetura-cei-frontend';

export const CEI_ADMIN_MENU_DADOS_PESSOAIS = 'dados-pessoais';
export const CEI_ADMIN_MENU_SOBRE = 'sobre';
export const CEI_ADMIN_MENU_SAIR = 'sair';

@Injectable({ providedIn: 'root' })
export class PersonalDataMenuService {
  /**
   * Monta itens do menu pessoal.
   *
   * Com `pessoaId`, usa `routerLink` direto.
   * Sem `pessoaId`, deixa `url` vazio — o host navega com `queryParams` (evita `?` no routerLink).
   */
  buildMenuItems(pessoaId?: number, _usuarioId?: number): CeiPersonalDataMenuItem[] {
    return [
      {
        label: 'Dados Pessoais',
        action: true,
        icon: 'person',
        value: CEI_ADMIN_MENU_DADOS_PESSOAIS,
        url: pessoaId != null ? `/admin/pessoas/atualizar/${pessoaId}` : undefined,
      },
      {
        label: 'Sobre',
        action: true,
        icon: 'info',
        value: CEI_ADMIN_MENU_SOBRE,
      },
      {
        label: 'Sair',
        action: true,
        icon: 'logout',
        value: CEI_ADMIN_MENU_SAIR,
      },
    ];
  }

  resolveItemAction(item: CeiPersonalDataMenuItem): string | undefined {
    if (typeof item.value === 'string') {
      return item.value;
    }

    return undefined;
  }
}
